var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChskLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 80,
    viewBox: "0 0 300 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.27 48.3474V33.7029H112.339V39.598C111.829 39.8236 111.209 39.9511 110.629 39.9511C109.649 39.9511 108.819 39.5784 108.819 38.5877V33.6931H103.888V39.1762C103.888 42.5406 106.128 44.159 109.309 44.159C110.359 44.159 111.399 43.9923 112.339 43.698V48.3375H117.27V48.3474Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.004 48.6808C145.585 48.6808 147.055 48.3865 148.375 47.798V43.3841C147.605 44.0511 146.175 44.4336 144.644 44.4336C142.684 44.4336 140.764 43.4724 140.764 41.1673C140.764 38.5484 142.704 37.5479 144.754 37.5479C146.075 37.5479 147.445 37.9893 148.275 38.5484V34.2424C146.955 33.6538 145.415 33.3694 143.884 33.3694C139.794 33.3694 135.693 35.6058 135.713 41.1673C135.713 46.5033 139.784 48.6808 144.014 48.6808H144.004Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.947 43.1193H159.077L162.248 48.3473H167.669L163.038 40.9613L167.579 33.7029H162.168L159.177 38.8917H157.947V33.7029H153.016V48.3473H157.947V43.1193Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.523 41.1673C133.543 35.6058 129.452 33.3694 125.351 33.3694C123.811 33.3694 122.281 33.6636 120.96 34.2522V38.3326C121.861 37.7441 123.301 37.3517 124.651 37.3517C126.421 37.3713 127.962 37.8618 128.532 39.4802H123.111V42.6779H128.572C127.952 44.1198 126.461 44.669 124.671 44.669C123.241 44.669 121.791 44.3355 120.96 43.6489V47.8078C122.281 48.3964 123.751 48.6906 125.221 48.6906C129.442 48.6906 133.523 46.5131 133.523 41.1869V41.1673Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8741 48.6808C87.1748 48.6808 90.6754 45.2478 90.6754 41.03C90.6754 36.8122 87.1748 33.3694 82.8741 33.3694C78.5734 33.3694 75.0728 36.8024 75.0728 41.03C75.0728 45.2576 78.5734 48.6808 82.8741 48.6808ZM82.8741 37.6754C84.6844 37.6754 86.1546 39.1762 86.1546 41.0202C86.1546 42.8642 84.6844 44.365 82.8741 44.365C81.0638 44.365 79.5935 42.8642 79.5935 41.0202C79.5935 39.1762 81.0638 37.6754 82.8741 37.6754Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8116 48.3473H73.8024L68.2115 33.7029H62.9406L57.3496 48.3473H62.3405L63.0006 46.4052H68.1414L68.8016 48.3473H68.8116ZM64.2008 42.9133L65.581 38.8623L66.9612 42.9133H64.2008Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4468 38.313H99.3971L100.917 33.7029H98.967L97.4468 38.313Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.436 38.313H96.3864L97.9066 33.7029H95.9563L94.436 38.313Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.529 38.313H174.48L176 33.7029H174.05L172.529 38.313Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.509 38.313H171.459L172.979 33.7029H171.029L169.509 38.313Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2493 44.5673C42.825 33.8143 36.0245 23.0495 25.06 20.5235C14.0955 17.9974 3.11894 24.6667 0.543193 35.4197C-2.03255 46.1726 4.7679 56.9374 15.7324 59.4635C26.697 61.9895 37.6735 55.3203 40.2493 44.5673Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9962 26.0618C33.736 24.7866 32.2957 23.688 30.7254 22.7856L11.8722 38.1559C10.342 39.4016 11.6622 41.8048 13.5625 41.2457L22.094 38.715L34.9962 26.0618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7352 38.0383L19.8034 41.285L6.35107 54.4777C7.6513 55.694 9.11154 56.7533 10.7018 57.5969L31.9554 40.2649C33.0556 39.3625 32.1055 37.6361 30.7352 38.0383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.116 36.2041H14.2627L7.15145 42.0109C6.41132 42.619 6.84139 43.8059 7.81156 43.8059H27.6649L34.7762 37.9991C35.5163 37.391 35.0862 36.2041 34.116 36.2041Z",
    fill: "#5DC5EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 40,
    fill: "white",
    transform: "translate(0 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChskLogo);
export default __webpack_public_path__ + "static/media/chsk_logo.bb92e659ecd6d384aac7e97a09635f56.svg";
export { ForwardRef as ReactComponent };